/**
 * Require:
 *  - user
 *  - videoId
 * Emit:
 *  - success upon a successful post
 * Provide for other component to call:
 *  - open
 *  - close
 *  - toggle
 */

<template>
  <div
    v-if="isOpen || persistent"
    class="comment__new comment__reply comment__reply-grey rounded"
    :class="isOpen ? '' : 'collapsed'"
  >
    <span
      class="comment__item__author__picture"
      :style="makeProfileStyle(user)"
    />

    <div
      v-show="isOpen"
      class="comment__new__wrapper"
    >
      <button
        type="button"
        class="vs-btn-legacy btn-close md-close"
        @click="close"
      />
      <div class="comment__new__content">
        <textarea
          ref="textarea"
          v-model="body"
          class="comment__new__textarea"
          :placeholder="$t('video.action.conversations.write_response')"
        />
      </div>
      <button
        type="submit"
        class="comment__new__send vs-btn btn btn--black--a05 rounded ladda-button"
        :disabled="isPosting"
        @click="postReply"
      >
        {{ $t('video.action.conversations.send') }}
        <i
          class="status"
          :class="isPosting ? 'loading' : ''"
        />
      </button>
    </div>
    <div
      v-show="!isOpen"
      class="comment__new__wrapper"
    >
      <div class="comment__new__content">
        <button
          class="vs-btn btn comment__new__btn"
          @click="open"
        >
          {{ $t(`video.action.conversations.${user ? 'write_response' : 'new_submit'}`) }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import webcall from '@/scripts/webcall';
import autosize from 'autosize';

export default {
  props: {
    persistent: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: undefined,
    },
    replyId: {
      type: Number,
      default: 0,
    },
    videoId: {
      type: String,
      required: true,
    },
    beforeOpen: {
      type: Function,
      default: () => Promise.resolve(),
    },
  },
  data() {
    return {
      isOpen: false,
      body: '',
      isPosting: false,
      hadAutoSized: false,
    };
  },
  methods: {
    // Public methods
    open() {
      this.beforeOpen()
        .then(() => {
          this.isOpen = true;
          this.$nextTick(() => {
            if (!this.hadAutoSized) {
              autosize(this.$refs.textarea);
              this.hadAutoSized = true;
            }

            this.$refs.textarea.focus();
          });
        })
      ;
    },
    close() {
      this.isOpen = false;
    },
    toggle() {
      this.isOpen = !this.isOpen;
    },

    // Private methods
    makeProfileStyle(user) {
      if (user && user.profile.profileImageUrl) {
        return {
          backgroundImage: `url('${user.profile.profileImageUrl}?height=70&width=70')`,
        };
      } else {
        return {
          background: 'black',
        };
      }
    },
    postReply() {
      this.isPosting = true;

      const params = {};
      params.body = this.body;
      if (this.replyId) params.in_reply_to = this.replyId;

      webcall.video.postComment({
        video_id: this.videoId,
        params,
      })
        .then((response) => {
          this.isPosting = false;
          this.body = '';
          this.$emit('success', response);
          this.close();
        })
        .catch((error) => {
          this.isPosting = false;

          const message = error.error || error.message;

          switch (message) {
            case 'Duplicate request':
            case 'Comment Creation Limit reached. Please try again later':
            default: {
            // TODO: Does locale affect error message?
            // TODO: Show user the error about the posting
              this.$modal.show('dialog', {
                title: 'Oops',
                text: message,
                buttons: [{
                  title: 'Close',
                }],
              });
            }
          }

          throw error;
        })
      ;
    },
  },
};

</script>

<style scoped lang="scss">
@import '~@/stylesheets/exports/_component-entry';

.comment__new {
  &::after {
    display: block;
    clear: both;
    content: "";
  }
  background-color: $grey-50;
  border: solid 1px $grey-100;
  min-height: $spacer*27;
  padding: 30px $spacer--x3 $spacer*9;
  position: relative;
  transition: padding 0.5s;

  .fa {
    margin-right: $spacer--x2;
  }

  &.collapsed {
    min-height: $spacer*10;
    padding: 30px $spacer--x3;
    &:hover {
      // background-color: $grey-100;
    }
  }

  .comment__item__author__picture {
    float: left;
  }

  .btn-close {
    position: absolute;
    top: $spacer--x3;
    right: $spacer--x3;
  }
}

.comment__new__btn, .comment__login__btn {
  margin: 0;
  padding: 0;
  line-height: 2em;
}

.comment__new__content {
  width: calc(100% - 40px);
  float: right;

  p {
    margin: 0;
  }
}

.comment__new__title {
  @include unstyledTextarea;
  font-size: em(24);
  font-weight: 300;
}

.comment__new__textarea {
  @include unstyledTextarea;
  width: 100%;
  min-height: 107px;
}

.comment__new__send {
  position: absolute;
  bottom: $spacer--x2;
  left: 50px;
}

.comment__new__contactus {
  position: absolute;
  bottom: 0;
  right: $spacer--x2;
  font-size: em(12);
}

.comment__reply {
  &::after {
    display: block;
    clear: both;
    content: "";
  }
  padding: $spacer--x3 $spacer--x3 $spacer*8;
  position: relative;
  margin-top: $spacer--x2;
  min-height: 202px;

  .btn-close {
    position: absolute;
    top: $spacer--x3;
    right: $spacer--x3;
  }

  &-white {
    background-color: #fff;
    border: 1px solid $grey-100;
  }
  &-grey {
    background-color: $grey-50;
  }
}

</style>
